module.exports = __webpack_public_path__ + "static/media/logo-roadrunners.8abb7681.png";